export const ShortNamesOfTestCategories = (data) => {
    const result={}
    const partNames = Object.keys(data);
    partNames.forEach((partName)=>{
        const categoriesNames = Object.keys(data[partName]);
        const partNameValue={}
        categoriesNames.forEach((categoryName)=>{
            // console.log(data[partName][categoryName]["1"]["1"]["additional_info"]["category_code"])
            const category_code=data[partName][categoryName]["1"]["1"]["additional_info"]["category_code"];
            Object.assign(partNameValue,{[categoryName]:category_code});
        })
        Object.assign(result,{[partName]:partNameValue});
    })
    return result;
}